export const NEW_SETTINGS_NOTIFICATION = {
  Message: 'Набор настроек изменился',
  Description: 'Нажмите кнопку "Применить" чтобы изменения вступили в силу',
  ButtonTitle: 'Применить'
};
